<script setup lang="ts">
defineProps({
  iconSvg: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <i v-html="iconSvg" />
</template>
